module.exports = __webpack_public_path__ + "img/evaluation-example-results.ad05b9fd.png";